"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// import { type } from "os";
// import {format as ft} from "util";
var sprintf_js_1 = require("sprintf-js");
String.prototype.equals = function (text) {
    return this.localeCompare(text) === 0;
};
String.prototype.equalsIgnoreCase = function (text) {
    return this.compareToIgnoreCase(text) === 0;
};
String.prototype.contains = function (text) {
    return this.indexOf(text) >= 0;
};
String.prototype.compareToIgnoreCase = function (text) {
    return this.toLowerCase().localeCompare(text.toLocaleLowerCase());
};
String.prototype.compareTo = function (text) {
    return this.localeCompare(text);
};
String.format = function (text) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return sprintf_js_1.sprintf.apply(void 0, __spreadArrays([text], args));
    //return ft(text,...args);
};
// function add<T>(this: T[],index:number, item: T) {
//   this.splice(index, 0, item);
// }
// function remove<T>(this: T[], index:number)  {
//      this.splice(index, 1);
// };
// function contains<T>(this: T[], item: T):boolean {
//     return this.indexOf(item)>=0;
// }
Array.prototype.add = function (index, item) {
    this.splice(index, 0, item);
};
Array.prototype.contains = function (item) {
    return this.indexOf(item) >= 0;
};
Array.prototype.remove = function (index) {
    if (typeof index == 'number')
        this.splice(index, 1);
    else
        this.splice(this.indexOf(index), 1);
};
// Object.defineProperty(Array.prototype,"contains",{
//     value: function<T>(this: T[],index:number,item:T) {
//         return this.splice(index, 0, item);
//       }
// });

//# sourceMappingURL=Extensions.js.map
